import colors from "../base/colors";
import boxShadows from "../base/boxShadows";

import rgba from "../functions/rgba";

const { white, grey, background } = colors;

const sidenav = {
  styleOverrides: {
    root: {
      whiteSpace: "nowrap",
      border: "none",
      zIndex: 1200,

      "&.MuiDrawer-paper": {
        position: "fixed" as const,
        top: 0,
        left: 0,
        height: "100vh",
        backgroundColor: background.sidenav,
        borderRight: `1px solid ${rgba(grey[200], 0.8)}`,
        boxShadow: boxShadows.lg,
        overflowY: "auto" as const,
        overflowX: "hidden" as const,
      },
    },

    docked: {
      transform: "translateX(0)",
      transition: "transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), width 0.2s cubic-bezier(0.4, 0, 0.2, 1)",

      "&.MuiDrawer-docked .MuiDrawer-paper": {
        transform: "none",
      },
    },

    paper: {
      position: "fixed !important" as any,
      top: "0 !important",
      height: "100vh !important",
      backgroundColor: `${background.sidenav} !important`,
      margin: "0 !important",
      borderRadius: "0 !important",
      boxShadow: `${boxShadows.lg} !important`,
      overflowY: "auto" as const,
      overflowX: "hidden" as const,
      zIndex: 1200,
    },

    paperAnchorLeft: {
      left: "0 !important",
      right: "auto !important",
      borderRight: `1px solid ${rgba(grey[200], 0.8)} !important`,
    },

    paperAnchorDockedLeft: {
      borderRight: `1px solid ${rgba(grey[200], 0.8)}`,
      boxShadow: boxShadows.lg,
      position: "fixed" as const,
      height: "100vh",
      top: 0,
      left: 0,
    },

    paperAnchorRight: {
      left: "auto !important",
      right: "0 !important",
      top: "0 !important",
      height: "100vh !important",
      margin: "0 !important",
      borderRadius: "0 !important",
      borderRight: "none !important",
      borderLeft: `1px solid ${rgba(grey[200], 0.8)} !important`,
    },
  },
};

export default sidenav;
